import axios from 'axios';


import defaultConfiguration from './defaultConfiguration';


export const types = {
  SET_CONFIGURATION: 'configuration/SET_CONFIGURATION',
};


export const setConfiguration = (configuration) => {
  return {
    type: types.SET_CONFIGURATION,
    configuration,
  };
};


export const loadConfiguration = (configurationUrl) => {
  return async (dispatch, getState) => {
    try {
      const { data: configuration } = await axios.get(configurationUrl);
      dispatch(setConfiguration(configuration));
    } catch (e) {
      /* eslint-disable no-console */
      console.warn('Failed to fetch configuration. Using defaults');
      /* eslint-enable no-console */

      dispatch(setConfiguration(defaultConfiguration));
    }
  };
};
